import { createFileRoute } from '@tanstack/react-router'
import { EmailScreen } from '@web/app/features/email'
import { MailOpen } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/security/email')({
  component: EmailScreen,
  staticData: {
    metaRoute: {
      title: 'Email',
      order: 3,
      icon: MailOpen,
    },
  },
})
